import { createFileRoute } from '@tanstack/react-router'
import { AIFlowPage } from '../../components/ai-flow/AIFlowPage'

export const Route = createFileRoute('/dev/ai-flow')({
  component: () => <AIFlowPage standalone />,
})
